import controller from './change-reason-modal-controller';
import template from './change-reason-modal.html';

const ChangeReasonModalComponent = {
    bindings: {
        modalInstance: '<',
        resolve: '<'
    },
    controller,
    template
};

export default ChangeReasonModalComponent;



// WEBPACK FOOTER //
// ./app/components/enter-virtual-data/change-reason-modal/change-reason-modal-component.js